import React, { ReactElement } from "react";
import classNames from "classnames";
import { ToolbarItemContentProps } from "./toolbar-item-content.types";

export const ToolbarItemContent = ({
  children,
  padding,
  className,
  ...rest
}: ToolbarItemContentProps): ReactElement => (
  <div
    className={classNames(
      "spark-toolbar__item--content",
      {
        "spark-toolbar__item--content__container": padding,
      },
      className
    )}
    {...rest}
  >
    {children}
  </div>
);

ToolbarItemContent.displayName = "ToolbarItemContent";
